import React from 'react'

import { UsersTable } from './sections/UsersTable';

export class UsersLayout extends React.Component {

    constructor(props){
      super(props)
      this.state = {}
    }
    
      render(){
        return(
          <React.Fragment>
            <UsersTable></UsersTable>
          </React.Fragment>
        )
      }
  }


// WEBPACK FOOTER //
// ./src/components/users/UsersLayout.js